module.exports = require("read-chunk");;